class DispatchTimer extends HTMLElement {
  constructor(){
    super();

    this.script = this.querySelector('script');
    this.data = this.script && this.script.innerText ? JSON.parse(this.script.innerText) : null;

    this.day = dayjs().get('date');
    this.month = dayjs().get('month') + 1;
    this.year = dayjs().get('year');
  }

  connectedCallback() {
    if (!this.data) return;

    const [ firstDispatch, secondDispatch ] = this.data.timers;
    if (!firstDispatch.enabled) return;

    const { data: { hours: h1, mins: m1, timezone }} = firstDispatch;
    const { data: { hours: h2, mins: m2 }} = secondDispatch;

    // need two digits
    if (this.day < 10) {
      this.day = `0${this.day}`;
    }
    if (this.month < 10) {
      this.month = `0${this.month}`;
    }

    const firstDeadlineString = `${this.year}-${this.month}-${this.day}T${h1}:${m1}:00${timezone}:00`;
    const secondDeadlineString = `${this.year}-${this.month}-${this.day}T${h2}:${m2}:00${timezone}:00`;

    const firstDeadline = dayjs(firstDeadlineString);
    const secondDeadline = dayjs(secondDeadlineString);

    const firstDeadlineDone = dayjs().isAfter(firstDeadline);
    const secondDeadlineDone = dayjs().isAfter(secondDeadline);

    if (!firstDeadlineDone) {
      if ( firstDispatch.available ) {
        this.renderElements(firstDispatch, firstDeadline);
      }
      // this.initTimer(firstDeadline);

      if (secondDispatch.enabled && !secondDeadlineDone) {
        this.renderElements(secondDispatch, secondDeadline);
        // this.initTimer(secondDeadline);
      }
    }
    else if (secondDispatch.enabled && !secondDeadlineDone) {
      this.renderElements(secondDispatch, secondDeadline);
      // this.initTimer(secondDeadline);
    }
  }

  renderElements(obj, deadline) {
    const div = document.createElement('div');
    div.classList.add('dispatch-timer');
    div.style.setProperty('--bg-color', obj.styles.color_bg);
    let terms = '';
    if(obj.messaging.terms != '') {
      terms = `<p class="terms">${obj.messaging.terms}</p>`;
    }
    div.innerHTML = `
    <div class="dispatch-timer--wrapper">
      <div class="dispatch-timer--left">
        <header>
          <p class="title">${obj.messaging.title}</p>
          ${terms}
        </header>
      </div>
      <div class="dispatch-timer--right">
        <p class="text">${obj.messaging.text}</p>
        <div class="timer">
          <span class="value hours">--</span>
          <span class="value minutes">--</span>
          <span class="value seconds">--</span>
        </div>
      </div>
    </div>
  `;

    this.appendChild(div);    

    this.initTimer(div, deadline);
  }

  initTimer(elem, deadline) {
    const hours = elem.querySelector('.hours'),
      mins = elem.querySelector('.minutes'),
      secs = elem.querySelector('.seconds');
    if (!hours || !mins || !secs) {
      elem.classList.add('hide');
      return;
    }

    const removeElement = (elem) => {
      if (!elem) return;
      elem.style.display = "none";
    }

    const startTimer = setInterval(function() {
      let diff = deadline.diff(dayjs(), 'second');
      let diff_s = Math.floor(diff % 60),
        diff_m = Math.floor(diff / 60 % 60),
        diff_h = Math.floor(diff / 60 / 60 % 60);

      if (diff >= 0) {
        hours.innerHTML = diff_h;
        mins.innerHTML = String(diff_m).padStart(2, '0');
        secs.innerHTML = String(diff_s).padStart(2, '0');
      } else {
        clearInterval(startTimer);
        removeElement(elem);
      }
    }, 1000);

    startTimer;
  }
}

if (!customElements.get('dispatch-timer')){
  customElements.define('dispatch-timer', DispatchTimer);
}